// extracted by mini-css-extract-plugin
export default {"CardLabel":"Destinations_CardLabel__trTU3","MainWrapper":"Destinations_MainWrapper__RJeRH"};